"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnNode = exports.cleanColumnDelimiter = void 0;
const base_1 = require("./base");
const sheet_db_1 = require("../../sheet_db");
const cleanColumnDelimiter = (id) => {
    const columnId = id.trim();
    if (columnId.startsWith('{') && columnId.endsWith('}')) {
        return columnId.slice(1, -1);
    }
    if (columnId.startsWith('__') && columnId.endsWith('__')) {
        return columnId.slice(2, -2);
    }
    return '';
};
exports.cleanColumnDelimiter = cleanColumnDelimiter;
class ColumnNode extends base_1.LeafNode {
    columnMapById;
    columnMapByName;
    cleanedToken;
    dataType;
    constructor(tabsContext, originalNode, parent) {
        super(originalNode, parent);
        const cleanedToken = (0, exports.cleanColumnDelimiter)(this.token);
        this.cleanedToken = cleanedToken;
        this.columnMapById = tabsContext.getCurrentTab().columnsById;
        this.columnMapByName = tabsContext.getCurrentTab().columnsByName;
        this._startPosition = originalNode.symbol.start + 1;
        this._endPosition = originalNode.symbol.stop;
        this._treeNodeType = base_1.TreeNodeType.COLUMN_NODE;
    }
    get column() {
        return this.columnMapById.get(this._abstractText ?? this.cleanedToken);
    }
    accept(v) {
        if (v.visitColumn)
            v.visitColumn(this);
    }
    translate(opts) {
        this.formatText(opts);
        return this.translation;
    }
    formatText(opts) {
        if (this.isPlanVariable())
            return this.formatPlanVariable(opts);
        if (opts.isOut)
            this.formatColumnOut();
        else
            this.formatColumnIn();
    }
    /*
      {colname} -> __1__
      __colname__ -> __1__
  
      Uses the cleaned token as the column name
    */
    formatColumnIn() {
        const columnByName = this.columnMapByName.get(this.cleanedToken);
        // column doesnt exist
        if (!columnByName) {
            this.abstractText = this.cleanedToken;
            this.translation = `__${this.cleanedToken}__`;
            // set default data type
            this.dataType = sheet_db_1.ColumnType.STRING;
            return;
        }
        this.abstractText = columnByName.column_id;
        this.dataType = columnByName.type;
        // {col name} -> __1__
        this.translation = `__${columnByName.column_id}__`;
    }
    /*
      __1__ -> {colname}
      {1} -> {colname}
  
      Uses the cleaned token as the column id
    */
    formatColumnOut() {
        // column doesnt exist
        if (!this.column) {
            this.abstractText = this.cleanedToken;
            this.translation = `{${this.cleanedToken}}`;
            // set default data type
            this.dataType = sheet_db_1.ColumnType.STRING;
            return;
        }
        this.abstractText = this.column.column_id;
        this.dataType = this.column.type;
        // __1__ -> {col name}
        this.translation = `{${this.column.name}}`;
    }
    formatPlanVariable(opts) {
        this.abstractText = this.cleanedToken;
        this.dataType = sheet_db_1.ColumnType.DATE;
        // {plan.start_date} -> __plan.start_date__
        this.translation = `__${this.cleanedToken}__`;
        // __plan.start_date__ -> {plan.start_date}
        if (opts.isOut)
            this.translation = `{${this.cleanedToken}}`;
    }
    getReturnType() {
        return this.dataType ?? sheet_db_1.ColumnType.STRING;
    }
    isPlanVariable() {
        return this.cleanedToken?.startsWith('plan') ?? false;
    }
    getPlanVariable(metadata) {
        for (const value of Object.values(sheet_db_1.MetadataFields)) {
            const variableFound = this.cleanedToken?.includes(value);
            if (variableFound) {
                switch (value) {
                    case sheet_db_1.MetadataFields.START_DATE:
                        return metadata.startDate;
                    case sheet_db_1.MetadataFields.END_DATE:
                        return metadata.endDate;
                    case sheet_db_1.MetadataFields.PAYOUT_DATE:
                        return metadata.payoutDate;
                }
            }
        }
        return metadata.endDate; // SOMEHOW this was the default before, there are client tests with this
    }
}
exports.ColumnNode = ColumnNode;
